module.exports = __webpack_public_path__ + "img/brochure_CR-thumbnail.d27e4043.jpg";